module.exports = __webpack_public_path__ + "img/1237.6c678ea2.gif";